import * as CryptoJS from 'crypto-js';

const SALT = '987c331b';

export const signCalc = (params: Record<string, unknown>, data: any) => {
  try {
    const queryString = Object.keys(params)
      .sort()
      .map((key) => `${key}=${params[key]}`)
      .join('&');
    const timestamp = Math.round(new Date().getTime() / 1000);

    const sign = CryptoJS.SHA1(
      `${queryString}${data ? JSON.stringify(data) : ''}x-timestamp=${timestamp}salt=${SALT}`
    );
    return [sign.toString(), timestamp];
  } catch (err) {
    console.error('sign calc error:', err);
    return [];
  }
};
